/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Plan_Edit_Menu_LabelInputs */

const en_us2_plan_edit_menu_label = /** @type {(inputs: Plan_Edit_Menu_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`More options for ${i?.name}`)
};

const pt_br2_plan_edit_menu_label = /** @type {(inputs: Plan_Edit_Menu_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mais opções para ${i?.name}`)
};

const es_419_plan_edit_menu_label = /** @type {(inputs: Plan_Edit_Menu_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Más opciones para ${i?.name}`)
};

const pt_pt2_plan_edit_menu_label = /** @type {(inputs: Plan_Edit_Menu_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mais opções para ${i?.name}`)
};

const fr_fr2_plan_edit_menu_label = /** @type {(inputs: Plan_Edit_Menu_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus d'options pour ${i?.name}`)
};

const de_de2_plan_edit_menu_label = /** @type {(inputs: Plan_Edit_Menu_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Weitere Optionen für ${i?.name}`)
};

const it_it2_plan_edit_menu_label = /** @type {(inputs: Plan_Edit_Menu_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Altre opzioni per ${i?.name}`)
};

/**
* | output |
* | --- |
* | "More options for {name}" |
*
* @param {Plan_Edit_Menu_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_menu_label = /** @type {((inputs: Plan_Edit_Menu_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Menu_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_menu_label(inputs)
	if (locale === "es-419") return es_419_plan_edit_menu_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_menu_label(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_menu_label(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_menu_label(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_menu_label(inputs)
	return en_us2_plan_edit_menu_label(inputs)
});
export { plan_edit_menu_label as "plan-edit.menu_label" }